import {GET_ALL_NOTIFICATION_START} from "../../types";

export const notifications = (payload) => ({
  type: GET_ALL_NOTIFICATION_START,
  payload,
});
